"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgPlay = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m8.006 2.802.036.024L18.591 9.86c.305.203.588.392.805.567.227.183.495.437.649.808a2 2 0 0 1 0 1.532c-.154.371-.422.625-.649.808-.217.175-.5.364-.805.567L8.006 21.198c-.373.248-.708.472-.993.627-.285.154-.676.33-1.132.303a2 2 0 0 1-1.476-.79c-.276-.364-.346-.788-.376-1.11C4 19.905 4 19.502 4 19.054V4.947c0-.449 0-.852.03-1.175.029-.322.1-.745.375-1.11a2 2 0 0 1 1.476-.79c.456-.027.847.15 1.132.304.285.154.62.378.993.626Z", fill: "currentColor" }) }))); };
exports.default = SvgPlay;
